module.exports = __webpack_public_path__ + "static/media/mp3.eb09246f.png";